"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@seedlang/utils");
var _mobx = require("mobx");
var _root_state = _interopRequireDefault(require("./root_state"));
var _lodash = require("lodash");
var _stores = require("@seedlang/stores");
var _class, _descriptor, _descriptor2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CATEGORIES = {
  essential: {
    name: 'Essential Cookies',
    description: 'These items are required to enable basic website functionality.'
  },
  analytics: {
    cookieName: 'allow-cookies',
    name: 'Analytics',
    description: 'These items help the website operator understand how its website performs, how visitors interact with the site, and whether there may be technical issues. With this storage type we don\'t send information that identifies a visitor.',
    showToggle: true
  },
  youtube: {
    cookieName: 'allow-youtube',
    name: 'YouTube Videos',
    description: 'Enable YouTube videos to be shown within this website',
    showToggle: true
  }
};
var PrivacySettingsState = (_class = /*#__PURE__*/function (_RootState) {
  function PrivacySettingsState() {
    var _this;
    _classCallCheck(this, PrivacySettingsState);
    _this = _callSuper(this, PrivacySettingsState);
    _initializerDefineProperty(_this, "savedChoices", _descriptor, _this);
    _initializerDefineProperty(_this, "choices", _descriptor2, _this);
    _this.applyDefaults();
    _this.loadFromCookies();
    _this.loadFromSavedUser();
    return _this;
  }
  _inherits(PrivacySettingsState, _RootState);
  return _createClass(PrivacySettingsState, [{
    key: "user",
    get: function get() {
      return _stores.AuthUserStore.showData;
    }
  }, {
    key: "togglableCategories",
    get: function get() {
      return Object.entries(CATEGORIES).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          attributes = _ref2[1];
        return _objectSpread({
          key: key
        }, attributes);
      }).filter(function (_ref3) {
        var showToggle = _ref3.showToggle,
          condition = _ref3.condition;
        return showToggle && (!condition || condition());
      });
    }
  }, {
    key: "applyDefaults",
    value: function applyDefaults() {
      var _this2 = this;
      this.togglableCategories.forEach(function (_ref4) {
        var key = _ref4.key;
        _this2.choices[key] = false;
      });
    }
  }, {
    key: "loadFromCookies",
    value: function loadFromCookies() {
      var _this3 = this;
      (0, _mobx.runInAction)(function () {
        _this3.togglableCategories.forEach(function (_ref5) {
          var key = _ref5.key;
          var cookieValue = (0, _utils.getCookieValue)(CATEGORIES[key].cookieName);
          if (cookieValue !== null) {
            _this3.choices[key] = _this3.savedChoices[key] = cookieValue;
          }
        });
      });
    }
  }, {
    key: "loadFromSavedUser",
    value: function loadFromSavedUser() {
      var _this4 = this;
      (0, _mobx.autorun)(function () {
        var _this4$user, _this4$user$privacySe, _this4$user2;
        if (!((_this4$user = _this4.user) !== null && _this4$user !== void 0 && _this4$user.id)) return;
        var privacySettings = (_this4$user$privacySe = (_this4$user2 = _this4.user) === null || _this4$user2 === void 0 ? void 0 : _this4$user2.privacySettings) !== null && _this4$user$privacySe !== void 0 ? _this4$user$privacySe : {};
        (0, _mobx.runInAction)(function () {
          _this4.togglableCategories.forEach(function (_ref6) {
            var key = _ref6.key;
            var savedValue = privacySettings[(0, _lodash.camelCase)(CATEGORIES[key].cookieName)];
            if ((0, _utils.isPresent)(savedValue)) {
              _this4.choices[key] = _this4.savedChoices[key] = savedValue;
            }
          });
        });
      });
    }
  }, {
    key: "isComplete",
    get: function get() {
      var _this5 = this;
      return this.togglableCategories.every(function (_ref7) {
        var key = _ref7.key;
        return _this5.isChoiceRecordedFor(key);
      });
    }
  }, {
    key: "isChoiceRecordedFor",
    value: function isChoiceRecordedFor(key) {
      return typeof this.savedChoices[key] !== 'undefined';
    }
  }, {
    key: "hasUnsavedChanges",
    get: function get() {
      var _this6 = this;
      return !this.togglableCategories.every(function (_ref8) {
        var key = _ref8.key;
        return _this6.savedChoices[key] === _this6.choices[key];
      });
    }
  }, {
    key: "acceptAll",
    value: function acceptAll() {
      var _this7 = this;
      this.togglableCategories.forEach(function (_ref9) {
        var key = _ref9.key;
        return _this7.setChoice(key, true);
      });
    }
  }, {
    key: "rejectAll",
    value: function rejectAll() {
      var _this8 = this;
      this.togglableCategories.forEach(function (_ref10) {
        var key = _ref10.key;
        return _this8.setChoice(key, false);
      });
    }
  }, {
    key: "saveChoices",
    value: function saveChoices() {
      var _this$user;
      if ((_this$user = this.user) !== null && _this$user !== void 0 && _this$user.id) {
        this.saveToUser();
      } else {
        this.saveToCookies();
      }
      this.savedChoices = _objectSpread({}, this.choices);
    }
  }, {
    key: "saveToCookies",
    value: function saveToCookies() {
      var _this9 = this;
      this.togglableCategories.forEach(function (_ref11) {
        var key = _ref11.key;
        (0, _utils.setCookieValue)(CATEGORIES[key].cookieName, _this9.choices[key]);
      });
    }
  }, {
    key: "saveToUser",
    value: function saveToUser() {
      var data = {
        allowCookies: this.choices['analytics'],
        allowYoutube: this.choices['youtube']
      };
      _stores.PrivacySettingsStore.update({
        data: data
      });
    }
  }, {
    key: "setChoice",
    value: function setChoice(key, value) {
      if (!CATEGORIES[key]) {
        throw new Error("Invalid key given to setChoice: ".concat(key));
      }
      this.choices[key] = value;
    }
  }, {
    key: "toggleChoice",
    value: function toggleChoice(key) {
      this.setChoice(key, !this.choices[key]);
    }
  }, {
    key: "isYoutubeAllowed",
    get: function get() {
      return this.savedChoices['youtube'];
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "savedChoices", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "choices", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "isComplete", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isComplete"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUnsavedChanges", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUnsavedChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "acceptAll", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "acceptAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rejectAll", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "rejectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveChoices", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveChoices"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setChoice", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setChoice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isYoutubeAllowed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isYoutubeAllowed"), _class.prototype), _class);
var _default = exports["default"] = new PrivacySettingsState();